import { IEnvironment } from '@env/ienvironment';

export const environment: IEnvironment = {
	production: false,
	enableWizardMocks: false,
	environmentName: 'QA',

	firebase: {},

	debug: false,
	log: {
		auth: false,
		store: false,
	},

	smartadmin: {
		api: null,
		db: 'smartadmin-angular'
	},

	identityApiUrl: 'https://api.nt-qa.icentral.io/identity',
	accountApiUrl: 'https://api.nt-qa.icentral.io/account-mgmt',
	commandingApiUrl: 'https://api.nt-qa.icentral.io/commanding',
	legacyBaseUrl: 'https://www-qa.irrigdev.net/iCentral',
	apiKey: 'CZSfxztfjSav4Fr4eRxr87ieYnMcuNo71pkkkjb3',

	youtubeUrl: 'https://www.youtube.com/user/RainMasterCS',
	helpAssetsBaseUrl: '/extra-assets/help',

	awsAppSyncUrl: 'https://appsync.nt-qa.icentral.io/graphql',
	awsAppSyncRegion: 'us-west-2',

	activitiesBatchSize: 20,

	bryntumCalendarLicenseKey: '7E07F1AF-7B68-11EF-AB90-0AA8B363F5DD',

	// The Power Automate trigger that stores feedback in the Product Feedback SharePoint list. One flow serves dev, QA and
	// prod; the environmentName sent with each item tells them apart. Its sig= is the only credential and ships in the
	// bundle by design: if it is abused, regenerate the trigger URL and replace it here and in the other two files.
	// eslint-disable-next-line max-len -- a signed URL, kept whole so it can be compared with the flow's trigger
	feedbackFlowUrl: 'https://default549366aee80a44b98adc52d0c29ba0.8b.environment.api.powerplatform.com:443/powerautomate/automations/direct/cu/11/workflows/07cfee2b68cd4ba7ab0ca0b3dcf0ba85/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=YJmVpKaWHmk3m_NvWTKdRfen9D1aOVrfBnKK2omn5SQ',
	trustpilotReviewUrl: ''
};
